import { UntypedFormControl } from '@angular/forms';

export interface IAdjustmentAndReclassesControlAddition {
    openingReClassControl: UntypedFormControl;
    openingAdjustmentControl: UntypedFormControl;
    closingReClassControl: UntypedFormControl;
    closingAdjustmentControl: UntypedFormControl;
    nameControl?: UntypedFormControl;
}
